export enum CHECKBOX_WITH_UNORDERED_LIST_CHILD_TYPE {
  CHECKBOX = "CHECKBOX",
  RADIO = "RADIO",
}
